import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { T } from '../../../../../../../Translations';
import { OfferingType } from '../../../../../Types';
import Omissions from './Omissions';

interface Props {
  omissions: NonEmptyList<OfferingType>;
}

function Recommendations({ omissions }: Props) {
  return (
    <div className="p-3 mt-4 bg-[#fffbeb] text-sm border-1 border-gray-300">
      <p className="text-sm mb-3">
        <T
          kind="So far you have not added any <omissions/> programs to this collection"
          omissions={<Omissions omissions={omissions} />}
        />
      </p>
      <p className="text-sm font-bold">
        <T
          kind="To get the most out of the license you chose it is recommended to add one or more <omissions/> programs to this collection."
          omissions={<Omissions omissions={omissions} />}
        />
      </p>
    </div>
  );
}

export default observer(Recommendations);
